/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-refund-payment.reducer';

export const PharmacyRefundPaymentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyRefundPaymentEntity = useAppSelector(state => state.pharmacyRefundPayment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyRefundPaymentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.detail.title">PharmacyRefundPayment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.id}</dd>
          <dt>
            <span id="paymentMethod">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.paymentMethod">Payment Method</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.paymentMethod}</dd>
          <dt>
            <span id="transactionDetails">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.transactionDetails">Transaction Details</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.transactionDetails}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.paidAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.lastupdated}</dd>
          <dt>
            <span id="forCredit">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.forCredit">For Credit</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.forCredit ? 'true' : 'false'}</dd>
          <dt>
            <span id="voided">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.voided">Voided</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.voided ? 'true' : 'false'}</dd>
          <dt>
            <span id="voidedReason">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.voidedReason">Voided Reason</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.voidedReason}</dd>
          <dt>
            <span id="voidedDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.voidedDate">Voided Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.voidedDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundPayment.refundBill">Refund Bill</Translate>
          </dt>
          <dd>{pharmacyRefundPaymentEntity.refundBill ? pharmacyRefundPaymentEntity.refundBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-refund-payment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-refund-payment/${pharmacyRefundPaymentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyRefundPaymentDetail;
